import { Module } from "vuex";
import { FormFields } from "@/types";
import { MUTATION_TYPES } from "@/lib/const";

const { CLEAR_DATA } = MUTATION_TYPES;

const componentConfigToState = <T>(fields: FormFields, staticFields: { [k: string]: any } = {}): T => {
  return {
    ...(fields.reduce((out: { [k: string]: any }, item: { name: string }) => {
      out[item.name] = null;
      return out;
    }, {}) as T),
    ...staticFields,
  };
};

const moduleFactory: <S extends Record<string, any>, R>(vModule: Module<S, R>) => Module<S, R> = vModule => {
  if (vModule.state && vModule.mutations && !vModule.mutations[CLEAR_DATA]) {
    const state = typeof vModule.state === "function" ? (vModule.state as () => any)() : vModule.state;
    vModule.mutations[CLEAR_DATA] = currentState => {
      Object.assign(currentState, state);
    };
  }
  return vModule;
};

export { componentConfigToState, moduleFactory };
